"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArtifactTagsApi = void 0;
var _authentication = require("../../../authentication");
var _config = require("../../../config");
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function value(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) {
              if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            }
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) {
      keys.push(key);
    }
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) {
        "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
      }
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
var ArtifactTagsApi = {
  getArtifactTagsBulk: function () {
    var _getArtifactTagsBulk = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(artifactType, artifactIds) {
      var adToken, apiHost, requestUrl, query, batchSize, totalIds, numBatches, results, i, startIdx, endIdx, batchIds, request, response, responseJson;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _authentication.AuthTokenProvider.acquireProdcatToken();
            case 2:
              adToken = _context.sent;
              apiHost = _config.Config.getValue("UI:ARTIFACT_TAGS_API_URL");
              requestUrl = "".concat(apiHost, "/graphql");
              query = " query ArtifactTags($artifactType: String!, $artifactIds: [String]!) {\n            artifactTags(artifactType: $artifactType, artifactIds: $artifactIds)\n            {\n              artifactId\n              artifactType\n              tags\n            }\n          }";
              batchSize = 2000;
              totalIds = artifactIds.length;
              numBatches = Math.ceil(totalIds / batchSize);
              results = [];
              i = 0;
            case 11:
              if (!(i < numBatches)) {
                _context.next = 35;
                break;
              }
              startIdx = i * batchSize;
              endIdx = Math.min((i + 1) * batchSize, totalIds);
              batchIds = artifactIds.slice(startIdx, endIdx);
              request = new Request(requestUrl, {
                method: "POST",
                headers: {
                  Authorization: "Bearer ".concat(adToken),
                  "content-type": "application/json"
                },
                body: JSON.stringify({
                  query: query,
                  variables: {
                    artifactType: artifactType,
                    artifactIds: batchIds
                  }
                })
              });
              _context.next = 18;
              return fetch(request);
            case 18:
              response = _context.sent;
              if (!(response.status === 200)) {
                _context.next = 31;
                break;
              }
              _context.next = 22;
              return response.json();
            case 22:
              responseJson = _context.sent;
              if (!responseJson.data) {
                _context.next = 27;
                break;
              }
              results.push.apply(results, _toConsumableArray(responseJson.data.artifactTags));
              _context.next = 29;
              break;
            case 27:
              if (!responseJson.errors) {
                _context.next = 29;
                break;
              }
              throw Error("Failed to load classification data");
            case 29:
              _context.next = 32;
              break;
            case 31:
              throw Error(response.statusText);
            case 32:
              i++;
              _context.next = 11;
              break;
            case 35:
              return _context.abrupt("return", results);
            case 36:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    function getArtifactTagsBulk(_x, _x2) {
      return _getArtifactTagsBulk.apply(this, arguments);
    }
    return getArtifactTagsBulk;
  }(),
  getArtifactTags: function () {
    var _getArtifactTags = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(artifactIdentifier) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", ArtifactTagsApi.callArtifactTagsApi("GET", artifactIdentifier.artifactType, artifactIdentifier.artifactId));
            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    function getArtifactTags(_x3) {
      return _getArtifactTags.apply(this, arguments);
    }
    return getArtifactTags;
  }(),
  getArtifactTagsSavePermission: function () {
    var _getArtifactTagsSavePermission = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(artifactType, artifactId) {
      var method, adToken, apiHost, request, response;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              method = "GET";
              _context3.next = 3;
              return _authentication.AuthTokenProvider.acquireProdcatToken();
            case 3:
              adToken = _context3.sent;
              apiHost = _config.Config.getValue("UI:ARTIFACT_TAGS_API_URL");
              request = new Request("".concat(apiHost, "/savePermission?artifactType=").concat(artifactType, "&artifactId=").concat(artifactId), {
                method: method,
                headers: {
                  Authorization: "Bearer ".concat(adToken),
                  "content-type": "application/json"
                }
              });
              _context3.next = 8;
              return fetch(request);
            case 8:
              response = _context3.sent;
              if (!(response.status === 200)) {
                _context3.next = 15;
                break;
              }
              _context3.next = 12;
              return response.json();
            case 12:
              return _context3.abrupt("return", _context3.sent.value);
            case 15:
              _context3.t0 = Error;
              _context3.next = 18;
              return response.json();
            case 18:
              _context3.t1 = _context3.sent.message;
              throw (0, _context3.t0)(_context3.t1);
            case 20:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    function getArtifactTagsSavePermission(_x4, _x5) {
      return _getArtifactTagsSavePermission.apply(this, arguments);
    }
    return getArtifactTagsSavePermission;
  }(),
  writeArtifactTags: function () {
    var _writeArtifactTags = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(artifactType, artifactId, tags) {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", ArtifactTagsApi.callArtifactTagsApi("PUT", artifactType, artifactId, tags));
            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    function writeArtifactTags(_x6, _x7, _x8) {
      return _writeArtifactTags.apply(this, arguments);
    }
    return writeArtifactTags;
  }(),
  writeArtifactTagsBulk: function () {
    var _writeArtifactTagsBulk = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(bulkSaveTagRequest) {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", ArtifactTagsApi.callArtifactTagsApiBulk("PUT", bulkSaveTagRequest));
            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
    function writeArtifactTagsBulk(_x9) {
      return _writeArtifactTagsBulk.apply(this, arguments);
    }
    return writeArtifactTagsBulk;
  }(),
  callArtifactTagsApi: function () {
    var _callArtifactTagsApi = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(method, artifactType, artifactId, tags) {
      var adToken, apiHost, request, response;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _authentication.AuthTokenProvider.acquireProdcatToken();
            case 2:
              adToken = _context6.sent;
              apiHost = _config.Config.getValue("UI:ARTIFACT_TAGS_API_URL");
              request = new Request("".concat(apiHost, "/tags?artifactType=").concat(artifactType, "&artifactId=").concat(artifactId), {
                method: method,
                headers: {
                  Authorization: "Bearer ".concat(adToken),
                  "content-type": "application/json"
                },
                body: method === "PUT" ? JSON.stringify({
                  tags: tags
                }) : undefined
              });
              _context6.next = 7;
              return fetch(request);
            case 7:
              response = _context6.sent;
              if (!(response.status === 200)) {
                _context6.next = 14;
                break;
              }
              _context6.next = 11;
              return response.json();
            case 11:
              return _context6.abrupt("return", _context6.sent.value);
            case 14:
              _context6.t0 = Error;
              _context6.next = 17;
              return response.json();
            case 17:
              _context6.t1 = _context6.sent.message;
              throw (0, _context6.t0)(_context6.t1);
            case 19:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
    function callArtifactTagsApi(_x0, _x1, _x10, _x11) {
      return _callArtifactTagsApi.apply(this, arguments);
    }
    return callArtifactTagsApi;
  }(),
  callArtifactTagsApiBulk: function () {
    var _callArtifactTagsApiBulk = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(method, bulkSaveTagRequest) {
      var adToken, apiHost, request, response;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _authentication.AuthTokenProvider.acquireProdcatToken();
            case 2:
              adToken = _context7.sent;
              apiHost = _config.Config.getValue("UI:ARTIFACT_TAGS_API_URL");
              request = new Request("".concat(apiHost, "/tags/bulk"), {
                method: method,
                headers: {
                  Authorization: "Bearer ".concat(adToken),
                  "content-type": "application/json"
                },
                body: method === "PUT" ? JSON.stringify(bulkSaveTagRequest) : undefined
              });
              _context7.next = 7;
              return fetch(request);
            case 7:
              response = _context7.sent;
              if (!(response.status === 200)) {
                _context7.next = 14;
                break;
              }
              _context7.next = 11;
              return response.json();
            case 11:
              return _context7.abrupt("return", _context7.sent);
            case 14:
              _context7.t0 = Error;
              _context7.next = 17;
              return response.json();
            case 17:
              _context7.t1 = _context7.sent.message;
              throw (0, _context7.t0)(_context7.t1);
            case 19:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));
    function callArtifactTagsApiBulk(_x12, _x13) {
      return _callArtifactTagsApiBulk.apply(this, arguments);
    }
    return callArtifactTagsApiBulk;
  }()
};
exports.ArtifactTagsApi = ArtifactTagsApi;